@if ({ error: error() }; as data) {
  @switch (data.error.code) {
    @case ('AVS') {
      {{ 'ERROR.AVS' | translate }}
    }
    @case ('ERR2') {
      {{ 'ERROR.2' | translate }}
    }
    <!-- Corriger ce combo erreur / traduction -->
    @case ('ERR10') {
      {{ 'ERROR.10' | translate }}
    }
    @case ('ERR11') {
      {{ 'ERROR.11' | translate }}
    }
    @case ('ERR12') {
      {{ 'ERROR.12' | translate }}
    }
    @case ('ERR13') {
      {{ 'ERROR.13' | translate }}
    }
    @case ('ERR18') {
      {{ 'ERROR.18' | translate }}
    }
    @case ('ERR19') {
      {{ 'ERROR.19' | translate }}
    }
    @case ('ERR21') {
      {{ 'ERROR.21' | translate }}
    }
    @case ('ERR29') {
      {{ 'ERROR.29' | translate }}
    }
    @case ('ERR30') {
      {{ 'ERROR.30' | translate }}
    }
    @case ('ERR31') {
      {{ 'ERROR.31' | translate }}
    }
    @case ('ERR32') {
      {{ 'ERROR.32' | translate }}
    }
    @case ('ERR40') {
      {{ 'ERROR.40' | translate }}
    }
    @case ('ERR50') {
      {{ 'ERROR.2' | translate }}
    }
    @case ('ERR51') {
      {{ 'ERROR.51' | translate }}
    }
    @case ('ERR70') {
      {{ 'ERROR.70' | translate }}
    }
    @case ('ERR71') {
      {{ 'ERROR.71' | translate }}
    }
    @case ('ERR121') {
      {{ 'ERROR.121' | translate }}
    }
    @case ('ERR402') {
      {{ 'ERROR.402' | translate }}
    }
    @case ('ERR403') {
      {{ 'ERROR.403' | translate }}
    }
    @case ('ERR404') {
      {{ 'ERROR.2' | translate }}
    }
    @case ('ERR418') {
      {{ 'ERROR.418' | translate }}
    }
    @default {
      {{ 'ERROR.2' | translate }}
    }
  }
}
